import { Outlet, useSearchParams, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { SubscriptionModal } from '@/features/dashboard/components/SubscriptionModal';
import { useSubscriptionStore } from '@/features/auth/stores/subscription.store';
import { useEffect } from 'react';
import '@/css/App.css';
import { useHelpStore } from '@/features/help/stores/help.store';
import { ContactModal } from '@/features/help/components/ContactModal';
import { DynamicTitle } from '@/features/ui/components/DynamicTitle';
import { useSupportImpersonationStore } from '@/features/support/stores/support-impersonation.store';
import { SUPPORT_IMPERSONATION_SESSION_EVENT } from '@/features/support/utils/support-impersonation-session.util';

export const App = () => {
  const { isModalOpen, closeSubscriptionModal } = useSubscriptionStore();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isContactModalOpen, closeContactModal } = useHelpStore();
  const syncSupportImpersonation = useSupportImpersonationStore((state) => state.syncFromStorage);

  useEffect(() => {
    // This effect can be used for other query param-based logic in the future,
    // but the checkout success logic has been moved to CheckoutSuccessPage.tsx
  }, [searchParams, navigate]);

  useEffect(() => {
    const handleSupportSessionChange = () => {
      syncSupportImpersonation();
    };

    window.addEventListener(SUPPORT_IMPERSONATION_SESSION_EVENT, handleSupportSessionChange);
    return () => {
      window.removeEventListener(SUPPORT_IMPERSONATION_SESSION_EVENT, handleSupportSessionChange);
    };
  }, [syncSupportImpersonation]);

  return (
    <>
      <DynamicTitle />
      <Outlet />

      <SubscriptionModal isOpen={isModalOpen} onClose={closeSubscriptionModal} />
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />

      <Toaster position="top-right" />
    </>
  );
};

export default App;
